export const stepBackgrounds = ['oklch(0.93 0.038 233)', 'oklch(0.77 0.075 235)', 'oklch(0.585 0.10 240)', 'oklch(0.455 0.085 246)', 'oklch(0.345 0.05 250)'];

export const stepMarkerBorders = ['oklch(0.74 0.085 233)', 'oklch(0.63 0.10 236)', 'oklch(0.55 0.105 240)', 'oklch(0.455 0.085 246)', 'oklch(0.345 0.05 250)'];

export const intensityGradient = ['oklch(0.86 0.05 233)', 'oklch(0.63 0.10 238)', 'oklch(0.345 0.055 250)'];

export const moveDownColor = '#2f7d33';

export const moveUpColor = '#c0392b';

export const endedColor = '#5b6b73';

export const highlightColor = '#d51a65';

export function stepIntensity(index: number, stepCount: number) {
  return stepCount > 1 ? index / (stepCount - 1) : 0;
}

export function stepColor(colors: string[], intensity: number) {
  const position = intensity * (colors.length - 1);
  const lower = Math.floor(position);
  return `color-mix(in oklch, ${colors[Math.ceil(position)]} ${(position - lower) * 100}%, ${colors[lower]})`;
}

export const internalCostColor = '#1f6b3a';

export const externalCostColor = '#86c995';
